/**
 * T-70: the activity opens on the newest comments, under the AI summary: this many on a wide screen,
 * one on a phone, with everything before the oldest of them behind "Show N earlier comments".
 */
export const RECENT_COMMENTS = 2;
export const RECENT_COMMENTS_PHONE = 1;

/** Where the shown blocks start when collapsed: the `keep`-th newest comment (0 when there aren't more). */
export function collapsedStart(blocks: Array<{ kind: string }>, keep: number): number {
  let seen = 0;
  for (let i = blocks.length - 1; i >= 0; i--) {
    if (blocks[i].kind !== 'chat') continue;
    seen++;
    if (seen === keep) {
      const earlier = blocks.slice(0, i).some((b) => b.kind === 'chat');
      return earlier ? i : 0;
    }
  }
  return 0;
}
